export enum ENUM__generation_tool_view_name {
  DEFAULT = 'default',

  ADJUST_COLOR = 'Adjust Color',
  ADJUST_TXT2IMG = 'Adjust Text',
  ADJUST_IMG2IMG = 'Adjust Image',

  ADJUST_DEPTH = 'Adjust Depth',
  ADJUST_LINES = 'Adjust Lines Canny',

  USE_ONE_REFERENCE = 'Use Reference',
  USE_TWO_REFERENCES = 'Use Two References',

  SELECT_MODELS = 'Select Models',
  SELECT_VAE = 'Select VAE',
  SELECT_LORAS = "Select LoRa's",
}
